import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialTableHeaderState } from "./initializes";
import type { HeadsType } from "./types";

const tableHeaderSlice = createSlice({
  name: "TableHeader",
  initialState: initialTableHeaderState,
  reducers: {
    setHeads(state, action: PayloadAction<HeadsType>) {
      state.heads = action.payload;
    },
    setHeadKey(state, action: PayloadAction<string[]>) {
      state.headKey = action.payload;
    },
    setHeadsMaster(state, action: PayloadAction<HeadsType>) {
      state.headsMaster = action.payload;
    },
    setHeadKeyMaster(state, action: PayloadAction<string[]>) {
      state.headKeyMaster = action.payload;
    },
    setChangedColumnWidthIndex(state, action: PayloadAction<number | null>) {
      state.changedColumnWidthIndex = action.payload;
    },
  },
});

export const { setHeads, setHeadKey, setHeadsMaster, setHeadKeyMaster, setChangedColumnWidthIndex } =
  tableHeaderSlice.actions;

export default tableHeaderSlice.reducer;
